import { render, staticRenderFns } from "./PlayersMessages.vue?vue&type=template&id=55e11dd4&"
import script from "./PlayersMessages.vue?vue&type=script&lang=js&"
export * from "./PlayersMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports